import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 85.5 77.2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M36.9 43.4c-6-5-10.6-10.9-13.6-17.3-.5-.9 0-2.7 1-3.6l4-3.6c3.5-3.2 3.5-7.3.5-10l-6-5.5c-4-3.6-10.1-3.6-14.1 0L5.1 6.7c-3.5 3.2-5 8.2-4 13.2 2.5 11.8 10.1 25 22.7 35.9S50.5 74 63.6 76.2c5.5.9 10.6-.5 14.6-4.1l3.5-3.2c4-3.6 4-9.1 0-12.7l-6-5.5c-3-2.7-7.6-2.7-10.6 0l-4.5 4.1c-1 .9-2.5 1.4-4 .9C49 53 42.4 48.9 36.9 43.4",
  style: {"fill":"none","stroke":"#0000e7","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }